var E = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.WARNING = "warning", e.ERROR = "error", e.SUCCESS = "success", e.WHITE = "white", e.LIGHT = "light", e.LIGHT_WITH_OUTLINE = "light-with-outline", e.BLUE = "blue", e))(E || {});
export {
  E as TagVariant
};
